module.exports = __webpack_public_path__ + "static/media/flamingo.45db6279.jpeg";